import { TitleProps } from './types';

import { Badge } from 'components/ui/badge';

export const Title = ({ title, badgeLabel, badgeValue }: TitleProps) => {
  return (
    <h1 className="text-sm font-bold sm:text-2xl">
      {title}{' '}
      {badgeLabel && badgeValue && (
        <Badge variant="outline" className="ml-2">
          {badgeValue} {badgeLabel}
        </Badge>
      )}
    </h1>
  );
};
